module.exports = __webpack_public_path__ + "static/media/shovel-snow.6c3f2d0c.svg";